// extracted by mini-css-extract-plugin
export default {"userInfo":"User_userInfo__+CerR","person":"User_person__MZn-5","default":"User_default__qJkpF","rotated":"User_rotated__gS96p"};